var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5H34C37.0376 0.5 39.5 2.96243 39.5 6V34C39.5 37.0376 37.0376 39.5 34 39.5H6C2.96243 39.5 0.5 37.0376 0.5 34V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5H34C37.0376 0.5 39.5 2.96243 39.5 6V34C39.5 37.0376 37.0376 39.5 34 39.5H6C2.96243 39.5 0.5 37.0376 0.5 34V6Z",
    stroke: "#DCDEE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6663 15.3334V16.6667M20.6663 23.3334V24.6667M20.6663 19.3334V20.6667M13.333 18C13.8634 18 14.3721 18.2108 14.7472 18.5858C15.1223 18.9609 15.333 19.4696 15.333 20C15.333 20.5305 15.1223 21.0392 14.7472 21.4143C14.3721 21.7893 13.8634 22 13.333 22V23.3334C13.333 23.687 13.4735 24.0261 13.7235 24.2762C13.9736 24.5262 14.3127 24.6667 14.6663 24.6667H25.333C25.6866 24.6667 26.0258 24.5262 26.2758 24.2762C26.5259 24.0261 26.6663 23.687 26.6663 23.3334V22C26.1359 22 25.6272 21.7893 25.2521 21.4143C24.8771 21.0392 24.6663 20.5305 24.6663 20C24.6663 19.4696 24.8771 18.9609 25.2521 18.5858C25.6272 18.2108 26.1359 18 26.6663 18V16.6667C26.6663 16.3131 26.5259 15.9739 26.2758 15.7239C26.0258 15.4738 25.6866 15.3334 25.333 15.3334H14.6663C14.3127 15.3334 13.9736 15.4738 13.7235 15.7239C13.4735 15.9739 13.333 16.3131 13.333 16.6667V18Z",
    stroke: "#101010",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketsIcon);
export default __webpack_public_path__ + "static/media/tickets-icon.9999e73a480d24e33cef1de450a687a0.svg";
export { ForwardRef as ReactComponent };